import React, { useEffect, useContext } from 'react';
import {
  IHeadState,
  ITagDescriptions,
} from './common';
import commitTagsToDom from './commitTagsToDom';

export const SetHead: React.FC<{ tags: ITagDescriptions }> = ({ tags, children }) => {
  const headState = useContext(HeadStateContext);

  // When server rendering, we cannot use useEffect, which is why we call
  // `setTags()` here.
  //
  // When client rendering, we want to wait until the commit phase before
  // updating the `<head>` so we don't cause unnecessary DOM updates, which is
  // why we also call `commitTags()` in `useEffect()`.
  headState.setTags(tags);

  const commitTags = useContext(CommitTagsContext);

  useEffect(() => {
    commitTags(tags);
  }, [commitTags, tags]);

  return (
    <React.Fragment>{children}</React.Fragment>
  );
};

// HeadState
const HeadStateContext = React.createContext<IHeadState>({
  setTags: () => {},
  getTags: () => ({}),
});
export const ProvideHeadState = HeadStateContext.Provider;

// commitTags()
export type CommitTagsFunction = (tags: ITagDescriptions) => void;

const CommitTagsContext = React.createContext<CommitTagsFunction>(() => {});

export const ProvideCommitTags = CommitTagsContext.Provider;

export const ProvideHeadDomComitter: React.FC = ({ children }) => (
  <ProvideCommitTags value={commitTagsToDom}>
    {children}
  </ProvideCommitTags>
);
